import { render, staticRenderFns } from "./VisitingMain.vue?vue&type=template&id=0f83e84b"
import script from "./VisitingMain.vue?vue&type=script&lang=js"
export * from "./VisitingMain.vue?vue&type=script&lang=js"
import style0 from "./VisitingMain.vue?vue&type=style&index=0&id=0f83e84b&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports